import { createAsyncThunk } from "@reduxjs/toolkit";
import advertiserApi from "api/advertiserApi";
import { formatQueryParams } from "helpers/format";

export const advertiserAgencyReport = createAsyncThunk("Advertiser Agency Report", async (params: any = {}) => {
  try {
    const response = await advertiserApi.advertiserAgencyReport(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getAllAdvertisers = async (params: any = {}) => {
  try {
    const response = await advertiserApi.allAdvertisers(params)
    return response;
  } catch (error) {
    return error;
  }
};